import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5723a7c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contents" }
const _hoisted_2 = { class: "price-details" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "金额明细", -1))
const _hoisted_4 = { class: "add-price" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "left" }, "咨询服务", -1))
const _hoisted_6 = { class: "right" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-a-Group14379" }, null, -1))
const _hoisted_8 = { class: "add-price" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "left" }, "商品金额", -1))
const _hoisted_10 = { class: "right" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-a-Group14379" }, null, -1))
const _hoisted_12 = { class: "reduce-price" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "left" }, "会员优惠", -1))
const _hoisted_14 = { class: "right" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-a-Group14379" }, null, -1))
const _hoisted_16 = { class: "reduce-price" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "left" }, "折扣优惠", -1))
const _hoisted_18 = { class: "right" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-a-Group14379" }, null, -1))
const _hoisted_20 = { class: "reduce-price" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "left" }, "优惠券金额", -1))
const _hoisted_22 = { class: "right" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-a-Group14379" }, null, -1))
const _hoisted_24 = { class: "total-price" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "left" }, "实付款", -1))
const _hoisted_26 = { class: "right" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-a-Group14379" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("ul", null, [
        _createElementVNode("li", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("span", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("span", null, _toDisplayString(_ctx.orderInfo.servicePrice), 1)
          ])
        ]),
        _createElementVNode("li", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("span", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("span", null, _toDisplayString(_ctx.orderInfo.goodsPrice), 1)
          ])
        ]),
        _createElementVNode("li", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("span", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("span", null, _toDisplayString(_ctx.orderInfo.vipPrice), 1)
          ])
        ]),
        _createElementVNode("li", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("span", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("span", null, _toDisplayString(_ctx.orderInfo.actPrice), 1)
          ])
        ]),
        _createElementVNode("li", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("span", _hoisted_22, [
            _hoisted_23,
            _createElementVNode("span", null, _toDisplayString(_ctx.orderInfo.couponPrice), 1)
          ])
        ]),
        _createElementVNode("li", _hoisted_24, [
          _hoisted_25,
          _createElementVNode("span", _hoisted_26, [
            _hoisted_27,
            _createElementVNode("span", null, _toDisplayString(_ctx.orderInfo.payPrice), 1)
          ])
        ])
      ])
    ])
  ]))
}